import React from 'react';
import styled from '@emotion/styled';

import RSDropdown, {
  DropdownProps as RSDropdownProps,
} from 'reactstrap/lib/Dropdown';

import RSDropdownItem, {
  DropdownItemProps as RSDropdownItemProps,
} from 'reactstrap/lib/DropdownItem';

import RSDropdownMenu, {
  DropdownMenuProps as RSDropdownMenuProps,
} from 'reactstrap/lib/DropdownMenu';

import RSDropdownToggle, {
  DropdownToggleProps as RSDropdownToggleProps,
} from 'reactstrap/lib/DropdownToggle';

import { primaryFontFamily } from '../../../styles/fonts';

export type StyledDropdownProps = RSDropdownProps;

export type StyledDropdownItemProps = RSDropdownItemProps & {
  selected?: boolean;
};

export type StyledDropdownMenuProps = RSDropdownMenuProps & {
  fluid: boolean;
};

export type StyledDropdownToggleProps = RSDropdownToggleProps & {
  showPlaceholder: boolean;
  fluid: boolean;
};

export const StyledDropdown = styled(
  ({ fluid, ...props }: StyledDropdownProps) => <RSDropdown {...props} />,
)<StyledDropdownProps>`
  position: relative;
`;

export const StyledDropdownItem = styled(
  ({ fluid, ...props }: StyledDropdownItemProps) => (
    <RSDropdownItem {...props} />
  ),
)<StyledDropdownItemProps>`
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ selected, theme }) =>
    selected ? `${theme.default.primaryColor}16` : 'transparent'};
  cursor: pointer;
  border: 0px solid ${({ theme }) => theme.default.colors.n2};
  color: ${({ theme }) => theme.default.colors.n5};
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  border-radius: 4px;
  ${primaryFontFamily}

  &:hover {
    background-color: ${({ theme }) => `${theme.default.primaryColor}08`};
  }
`;

export const StyledDropdownMenu = styled(
  ({ fluid, ...props }: StyledDropdownMenuProps) => (
    <RSDropdownMenu {...props} />
  ),
)<StyledDropdownMenuProps>`
  width: ${({ fluid }) => (fluid ? '100%' : 'auto')};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(1)};
  font-family: ${primaryFontFamily};
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.default.colors.n2};
  border-radius: 4px;
  box-shadow: 0 2px 4px ${({ theme }) => theme.default.colors.n2};
  background-color: ${({ theme }) => theme.default.colors.n0};
`;

export const StyledDropdownToggle = styled(
  ({ showPlaceholder, fluid, ...props }: StyledDropdownToggleProps) => (
    <RSDropdownToggle {...props} />
  ),
)<StyledDropdownToggleProps>`
  width: ${({ fluid }) => (fluid ? '100%' : 'auto')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(4)} 14px;
  border-radius: 4px;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.default.colors.n2};
  background-color: ${({ theme }) => theme.default.colors.n0};
  cursor: pointer;

  color: ${({ theme, showPlaceholder }) =>
    showPlaceholder ? theme.default.colors.n5 : theme.default.colors.n3};

  ${primaryFontFamily}
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;

  &:focus {
    border-color: ${({ theme }) => theme.default.primaryColor};
    outline: none;
    box-shadow: ${({ theme }) => `0 0 0 1px ${theme.default.primaryColor}`};
  }

  &.is-invalid {
    border-color: ${({ theme }) => theme.default.colors.Feedback.Error};
    outline: none;
  }
`;
